import { useEffect, useState } from 'react';
// @mui/material components
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';

// material-ui icons
import Assignment from '@mui/icons-material/Assignment';
import { Visibility } from '@mui/icons-material';

// core components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import Button from 'components/CustomButtons/Button.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Table from 'components/Table/Table.js';

import { selectSessionStatus } from '../../features/session/sessionSlice';

import { useGetBaseRolesQuery, useLazyGetBaseRolesQuery } from 'api/role.api';
import styles from 'assets/jss/material-dashboard-pro-react/views/clientEditStyle.js';

const useStyles = makeStyles(styles);

export default function Roles(props) {
  const classes = useStyles();

  const sessionStatus = useSelector(selectSessionStatus);
  const { data: roles } = useGetBaseRolesQuery();
  const [triggerGetBaseRoles] = useLazyGetBaseRolesQuery();

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (sessionStatus === 'active' && !initialized) {
      setInitialized(true);
    }
  }, [sessionStatus, initialized]);

  useEffect(() => {
    if (
      (sessionStatus === 'active' && initialized && roles === null) ||
      roles.length === 0
    )
      triggerGetBaseRoles().unwrap();
  }, [sessionStatus, initialized, roles]);

  const handleEditRole = (index) => {
    props.history.push('/admin/baserole', { role: roles[index], new: false });
  };

  const actionButton = (Icon, color, handler, key) => {
    return (
      <Button
        key={key}
        color={color}
        simple
        className={classes.actionButton}
        onClick={() => handler()}
      >
        <Icon className={classes.icon} />
      </Button>
    );
  };

  const roleList = () => {
    const listOfRoles = roles.map((role, key) => {
      var roleData = [];
      var actionButtons = [];
      roleData.push(role.scope);
      roleData.push(role.name);
      roleData.push(role.description);
      actionButtons.push(
        actionButton(Visibility, 'warning', () => handleEditRole(key), key)
      );
      roleData.push(actionButtons);
      return roleData;
    });
    return listOfRoles;
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color='rose' icon>
            <CardIcon color='rose'>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Roles</h4>
          </CardHeader>
          <CardBody>
            <Table
              tableHead={['Scope', 'Role', 'Description', 'Actions']}
              tableData={roleList()}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
